import React, { useState } from "react";
import "../css/NewsLetter.css"; // Individual component styles

// Import your custom background and icon assets here
import newsletterBg from "../../images/Banner7.png"; 
import mailIcon from "../../images/HomeIcon.png"; 

function Newsletter() {
  const [email, setEmail] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatusMessage("");

    try {
      // Sending email data via POST request (adjust headers/body format based on your PHP backend requirements)
      const response = await fetch("https://crestestlearning.com/mailServerCrestest/send_mail_user.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Change to "application/x-www-form-urlencoded" if your PHP script expects form data
        },
        body: JSON.stringify({ email: email }),
      });

      // If your API returns JSON, parse it:
      // const data = await response.json();

      if (response.ok) {
        setStatusMessage("Subscribed successfully! Check your inbox.");
        setEmail("");
      } else {
        setStatusMessage("Subscription failed. Please try again later.");
      }
    } catch (error) {
      console.error("Error connecting to mail server:", error);
      setStatusMessage("Network error. Please check your connection.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section 
      className="newsletter-section" 
      style={{ backgroundImage: `url(${newsletterBg})` }}
    >
      <div className="container position-relative">
        
        {/* Centered Top Circle Floating Icon */}
        <div className="newsletter-floating-circle">
          <img src={mailIcon} alt="Mail Icon" className="newsletter-icon" />
        </div>

        {/* Main Form Box Container */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center newsletter-content-box">
            
            <h2 className="newsletter-heading">Stay Connected With Us</h2>
            <p className="newsletter-subtext">
              Subscribe to our monthly briefing for premium updates, framework deep-dives, and exclusive ecosystem releases.
            </p>

            {/* Sleek Inline Email Subscription Form */}
            <form onSubmit={handleSubscribe} className="newsletter-form-wrapper">
              <div className="input-group-sleek">
                <input 
                  type="email" 
                  className="sleek-input" 
                  placeholder="Enter your email address..." 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                  required 
                />
                <button type="submit" className="btn sleek-subscribe-btn" disabled={isLoading}>
                  {isLoading ? "SUBSCRIBING..." : "SUBSCRIBE"}
                </button>
              </div>
            </form>

            {/* Optional Status Feedback Message */}
            {statusMessage && (
              <p className="newsletter-status-message mt-3" style={{ color: "#fff" }}>
                {statusMessage}
              </p>
            )}

          </div>
        </div>

      </div>
    </section>
  );
}

export default Newsletter;